export default class {

    constructor (TokenService, ROLE_PRIVILEGE_ENUM, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM,
                 ROLE_COMPANY_PRIVILEGE_ENUM, AUTH_PRIVILEGE_ENUM, COMPANY_SITE_ACCESS_ENUM) {
        this.TokenService = TokenService;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.ROLE_COMPANY_PRIVILEGE_ENUM = ROLE_COMPANY_PRIVILEGE_ENUM;
        this.AUTH_PRIVILEGE_ENUM = AUTH_PRIVILEGE_ENUM;
        this.COMPANY_SITE_ACCESS_ENUM = COMPANY_SITE_ACCESS_ENUM;
    }

    getSuperAdminPrivileges () {
        return [this.AUTH_PRIVILEGE_ENUM.KEYS.SUPER_ADMIN];
    }

    getCompanyAdminPrivileges () {
        return this.getSuperAdminPrivileges().concat([
            this.ROLE_COMPANY_PRIVILEGE_ENUM.KEYS.COMPANY_MANAGE
        ]);
    }

    getCourseManagePrivileges () {
        return this.getCompanyAdminPrivileges().concat([
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE,
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE
        ]);
    }

    getFormManagePrivileges () {
        return this.getCompanyAdminPrivileges().concat([
            this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_MANAGE
        ]);
    }

    /**
     * Privileges used to filter forms in course version add/edit view
     * @returns {(string)[]}
     */
    getCourseVersionFormViewPrivileges () {
        return [
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE,
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE,
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW,
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE,
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_AUTOMATIC_PLANNING_GROUP_MANAGE
        ];
    }

    isSuperAdmin () {
        return this.TokenService.hasPrivilege(this.AUTH_PRIVILEGE_ENUM.KEYS.SUPER_ADMIN);
    }

    isCompanyAdmin () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_PRIVILEGE_ENUM.KEYS.COMPANY_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canViewAnalytics () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.ANALYTICS_VIEW)
            || this.isSuperAdmin()
        );
    }

    isCourseAdmin () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE)
            || this.isCompanyAdmin()
        );
    }

    canViewUsers () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_MANAGE)
            || this.isCompanyAdmin()
        );
    }

    canManageUsers () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_MANAGE)
            || this.isCompanyAdmin()
        );
    }

    canViewCourses () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_AUTOMATIC_PLANNING_GROUP_MANAGE)
            || this.isCompanyAdmin()
        );
    }

    canManageCourses () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE)
            || this.isCompanyAdmin()
        );
    }

    canManageOccurrences () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE)
            || this.isCompanyAdmin()
        );
    }

    canViewPlanning () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_MANAGE)
            || this.isCompanyAdmin()
        );
    }

    canManagePlanning () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_MANAGE)
            || this.isCompanyAdmin()
        );
    }

    canManageMaterials () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.MATERIALS_MANAGE)
            || this.isCompanyAdmin()
        );
    }

    canViewReports () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_COURSES_AND_TARGETED_EMPLOYEES_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_COURSES_RESULTS_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_EMPLOYEE_RESULTS_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_BUDGET_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.REPORTS_LICENCE_POINTS_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_OVERVIEW_VIEW)
            || this.isCompanyAdmin()
        );
    }

    canViewCoursesAndUsersReports () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_OVERVIEW_VIEW)
               || this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.REPORTS_LICENCE_POINTS_VIEW)
               || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_EMPLOYEE_COURSE_PROGRESS_VIEW)
               || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_EMPLOYEE_RESULTS_VIEW)
               || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_COURSES_RESULTS_VIEW)
               || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_COURSES_AND_TARGETED_EMPLOYEES_VIEW)
               || this.isCompanyAdmin()
        );
    }

    canViewLicencePointsReport () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.REPORTS_LICENCE_POINTS_VIEW)
            || this.isSuperAdmin()
        );
    }

    canViewCoursesAndTargetedEmployeesReport () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_COURSES_AND_TARGETED_EMPLOYEES_VIEW)
            || this.isCompanyAdmin()
        );
    }

    canViewCoursesResultReport () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_COURSES_RESULTS_VIEW)
            || this.isCompanyAdmin()
        );
    }

    canViewOverviewReport () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_OVERVIEW_VIEW)
            || this.isCompanyAdmin()
        );
    }

    canViewEmployeeResultsReport () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_EMPLOYEE_RESULTS_VIEW)
            || this.isCompanyAdmin()
        );
    }

    canManageForms () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageValidations () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.VALIDATIONS_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageEvents () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.EVENTS_MANAGE)
            || this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.EVENTS_ADMINISTRATE)
            || this.isSuperAdmin()
        );
    }

    canAdministrateEvents () {
        return this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.EVENTS_ADMINISTRATE)
        || this.isSuperAdmin();
    }

    canManage360 () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_360_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canView360Reports () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_360_REPORT_VIEW)
            || this.isSuperAdmin()
        );
    }

    canManageSurveys () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_SURVEY_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canViewSurveyReports () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_SURVEY_REPORT_VIEW)
            || this.isSuperAdmin()
        );
    }

    canViewEmployeeCourseProgressReport () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_EMPLOYEE_COURSE_PROGRESS_VIEW)
            || this.isCompanyAdmin()
        );
    }

    canViewBudgetReport () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_BUDGET_VIEW)
            || this.isCompanyAdmin()
        );
    }

    canManageLicencePoints () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.LICENCE_POINTS_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManagePerformanceReviews () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PERFORMANCE_REVIEW_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageApplications () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.APPLICATION_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageExternalParticipations () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.EXTERNAL_PARTICIPATIONS_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageAutomatedPlanningGroups () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_AUTOMATIC_PLANNING_GROUP_MANAGE)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE)
            || this.isCompanyAdmin()
        );
    }

    canViewAutomatedPlanningGroups () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE)
            || this.canManageAutomatedPlanningGroups()
        );
    }

    isSiteAccessForAllUsers () {
        return this.TokenService.getSiteAccessForAllSites() === this.COMPANY_SITE_ACCESS_ENUM.KEYS.ALL_CAN_MANAGE;
    }

    canManagePastLicencePeriodPoints () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PAST_PERIOD_LICENCE_POINTS_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManagePreconditionsOnLicencePoints () {
        return this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PRECONDITION_LICENCE_POINTS_MANAGE);
    }

    canManageTemplates () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.NOTIFICATION_TEMPLATES_MANAGE)
            || this.isCompanyAdmin()
        );
    }

    canExportSurveyResults () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.FORMS_SURVEY_CSV_EXPORT)
            || this.isSuperAdmin()
        );
    }

    canExportLicencePointsReport () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.REPORTS_LICENCE_POINTS_CSV_EXPORT)
            || this.isSuperAdmin()
        );
    }

    canViewBudget () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.BUDGET_VIEW)
            || this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.BUDGET_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageBudget () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_PRIVILEGE_ENUM.KEYS.BUDGET_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageTasklistTemplates () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.TASKLIST_TEMPLATES_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManagePrivacySettings () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PRIVACY_SETTINGS_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageTasklists () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.TASKLIST_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageSkills () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.SKILL_MANAGE)
            || this.isSuperAdmin()
        );
    }

    canManageUserSkills () {
        return (
            this.TokenService.hasPrivilege(this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.USER_SKILL_MANAGE)
            || this.isSuperAdmin()
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/services/privilege/index.js